import { useState, type FormEvent } from "react";
import clsx from "clsx";
import { Modal } from "./Modal";

interface UserIdentityModalProps {
  onSubmit: (name: string) => void;
}

export function UserIdentityModal({ onSubmit }: UserIdentityModalProps) {
  const [name, setName] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed) onSubmit(trimmed);
  };

  return (
    <Modal
      open
      onClose={() => {}}
      title="Welcome to PlotPlanGo"
      description="Enter a display name so your changes can be attributed to you."
      icon="person"
      size="sm"
      dismissible={false}
      showCloseButton={false}
    >
      <p className="text-sm text-secondary mb-6 leading-relaxed">
        Enter a display name so your changes can be attributed to you.
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          className="input-base mb-4"
        />
        <button
          type="submit"
          disabled={!name.trim()}
          className={clsx(
            "w-full py-2.5 px-4 rounded-lg text-sm font-bold font-sans border-none transition-colors",
            name.trim()
              ? "bg-primary text-white cursor-pointer"
              : "bg-gray-300 text-white cursor-not-allowed",
          )}
        >
          Continue
        </button>
      </form>
    </Modal>
  );
}
